document.addEventListener("DOMContentLoaded", function() {

    setTimeout(function() {
            document.querySelectorAll('.humi-job-board-posting').forEach(posting => {
                const linkElement = posting.querySelector('.humi-job-board-posting-title a');

                if (linkElement) {
                    const url = linkElement.getAttribute('href');

                    posting.setAttribute('data-url', url);
                    posting.style.cursor = 'pointer';

                    posting.addEventListener('click', function(event) {
                        if (event.target.tagName !== 'A') {
                            window.open(url, '_blank');
                        }
                    });

                    posting.addEventListener('mouseover', function() {
                        posting.style.transform = 'scale(1.05)';
                        posting.style.transition = 'all .3s';
                    });

                    posting.addEventListener('mouseout', function() {
                        posting.style.transform = 'scale(1)';
                        posting.style.transition = 'all .3s';
                    });
                }
            });

            document.querySelectorAll('.humi-job-board-posting-link a').forEach(link => {
                link.textContent = '→';
            });

    }, 2000);

});
